var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasicDialog',_vm._b({on:{"confirm":_vm.handleConfirm,"close":_vm.handleClose}},'BasicDialog',_vm.dialogConfig,false),[_c('div',{attrs:{"id":"preview_content_design"}}),_c('BasicForm',_vm._b({ref:"FormRef"},'BasicForm',_vm.formConfig,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }